import {ThemeIcon as MantineThemeIcon} from '@mantine/core';

/**
 * Themed icon container — design-layer pass-through over Mantine `ThemeIcon`.
 * @registry Pass-through Mantine ThemeIcon; import this instead of @mantine/core outside src/design.
 */
export const ThemeIcon = MantineThemeIcon;
